import api from '@/api/api'
import { useRequestsStore } from '@/stores/requests'
import type { JobSearchItem } from '@/types/JobSearch'

export async function searchJobs(searchText: string) {
  useRequestsStore().Search.increment()
  const { status, data } = await api.post<JobSearchItem[]>('/jobs/search', {
    searchText,
  })
  useRequestsStore().Search.decrement()

  return status === 200 ? data : []
}
